import { render, staticRenderFns } from "./OrderProductItem.vue?vue&type=template&id=b0906576&scoped=true&"
import script from "./OrderProductItem.vue?vue&type=script&lang=js&"
export * from "./OrderProductItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductItem.vue?vue&type=style&index=0&id=b0906576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0906576",
  null
  
)

export default component.exports